import backendAxios from '../utils/backendAxios';

export const submitReview = async (bookingId, rating, comentario) => {
  try {
    const res = await backendAxios.post('/api/reviews', { bookingId, rating, comentario });
    return res.data;
  } catch (err) {
    console.error('Error submitting review', err);
    return null;
  }
};

// conComentario: solo las reseñas que traen texto (las que únicamente dejaron estrellas no cuentan como comentario)
export const getServiceReviews = async (servicioId, { conComentario = false } = {}) => {
  try {
    const res = await backendAxios.get(`/api/reviews/servicio/${servicioId}`, {
      params: conComentario ? { conComentario: 1 } : undefined
    });
    return res.data;
  } catch (err) {
    console.error('Error fetching service reviews', err);
    return [];
  }
};

export const getProviderReviews = async (proveedorId) => {
  try {
    const res = await backendAxios.get(`/api/reviews/proveedor/${proveedorId}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching provider reviews', err);
    return [];
  }
};

// Comentarios de una página (grupo, negocio o independiente): solo los de los servicios que esa página
// tiene vinculados, ya paginados. Devuelve { reviews, total, page, pages, limit } o null si falla.
export const getPageReviews = async (paginaId, page = 1, limit = 5) => {
  try {
    const res = await backendAxios.get(`/api/reviews/pagina/${paginaId}`, { params: { page, limit } });
    return res.data;
  } catch (err) {
    console.error('Error fetching page reviews', err);
    return null;
  }
};

export const getClientReviews = async (clienteId) => {
  try {
    const res = await backendAxios.get(`/api/reviews/cliente/${clienteId}`);
    return res.data;
  } catch (err) {
    console.error('Error fetching client reviews', err);
    return null;
  }
};
